import { render, staticRenderFns } from "./scan_kdy.vue?vue&type=template&id=226235c1&scoped=true&"
import script from "./scan_kdy.vue?vue&type=script&lang=js&"
export * from "./scan_kdy.vue?vue&type=script&lang=js&"
import style0 from "./scan_kdy.vue?vue&type=style&index=0&id=226235c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226235c1",
  null
  
)

export default component.exports